import { useState } from "react";
import { MdChevronRight, MdExpandMore } from "react-icons/md";

export default function UploadInstructions() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="card mb-4"
      style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.12)" }}
    >
      <button
        type="button"
        className="card-header d-flex align-items-center gap-2 border-0 bg-transparent text-start w-100 py-3 px-4"
        style={{
          cursor: "pointer",
          color: "#0d2d4a",
          fontWeight: 600,
          fontSize: "0.95rem",
        }}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls="instructions-body"
      >
        {isOpen ? <MdExpandMore size={18} /> : <MdChevronRight size={18} />}
        Instructions
      </button>

      {isOpen && (
        <div
          id="instructions-body"
          className="card-body"
          style={{ fontSize: "0.9em" }}
        >
          <ol className="list-unstyled">
            <li>
              <div className="h5">1. Understand the Process</div>
              <ul className="list-style-disc mb-3">
                <li>
                  This process allows LEAs to scan a file of new child records
                  prior to uploading to see if they have existing CSPPIDs.
                </li>
                <li>
                  Each record will be searched statewide for existing CSPPIDs
                  with a near match of the first and last name of the child and
                  an exact match of the date of birth.
                </li>
                <li>
                  The response file will return any matches found along with a
                  match score which indicates how closely the records match an
                  existing CSPPID. A perfect match returns a score of 100.
                </li>
              </ul>
            </li>
            <li>
              <div className="h5">2. Creating the Upload File</div>
              <ul className="list-style-disc mb-3">
                <li>
                  The upload file must be a CSV in the exact same format as the
                  Child file with the first column changed from{" "}
                  <strong>CHLD</strong> to <strong>CSPPIDCandidate</strong>.
                </li>
                <li>
                  Information on the Child file format is available from the{" "}
                  <a
                    href="https://www.cde.ca.gov/sp/cd/ci/capsdacsupportlanding.asp"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CAPSDAC support website
                  </a>
                  .
                </li>
              </ul>
            </li>
            <li>
              <div className="h5">3. Uploading the File(s)</div>
              <ul className="list-style-disc mb-3">
                <li>
                  In the Selected Files section of this page, click Browse Files
                  and select your CSV files to upload or drag &amp; drop them
                  in.
                </li>
                <li>Click the Submit Files button to upload the files.</li>
              </ul>
            </li>
            <li>
              <div className="h5">4. Getting the Results</div>
              <ul className="list-style-disc mb-3">
                <li>
                  At the bottom of this screen is a table of Submitted Files.
                </li>
                <li>
                  The newly submitted request will show up on top with a status
                  of <strong>Request Received</strong>.
                </li>
                <li>
                  When the Match Tool process finishes, the status will update.
                </li>
                <li>
                  If <strong>Rejected</strong>, clicking the row will display
                  information about the errors.
                </li>
                <li>
                  If <strong>Posted</strong>, an icon will show that can be
                  clicked to download the resulting CSV.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      )}
    </div>
  );
}
